import React from 'react'
import { useTranslation } from '@mc/i18n'
import { BOGO_I18N_NAMESPACE } from '../../../i18n'
import styles from './styles.module.scss'

export const TilesMobileStacked = () => {
  const { t } = useTranslation(BOGO_I18N_NAMESPACE)

  return (
    <div className='row'>
      {['tile1', 'tile2', 'tile3'].map((key) => (
        <div key={key} className='col-12'>
          <div
            className={`${styles.tileContainer} mc-py-4 mc-px-8 mc-corners--md`}
          >
            <div className='mc-px-1 d-flex'>
              <div className='flex-auto mc-mr-4'>
                <h3 className={`${styles.stepNumber} mc-text--bold mc-mb-4`}>
                  {t(`howItWorksTiles.${key}.stepNumber`)}
                </h3>
              </div>
              <div className='flex-grow-1'>
                <h4 className='mc-text-h2 mc-mb-1'>
                  {t(`howItWorksTiles.${key}.title`)}
                </h4>
                <p className='mc-text-small mc-text-color--medium mc-mb-1'>
                  {t(`howItWorksTiles.${key}.description`)}
                </p>
                <p className='mc-text-small mc-text-color--medium'>
                  {t(`howItWorksTiles.${key}.disclaimer`)}
                </p>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
